import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HtmlTemplate } from '../dto/templates/html-template';

@Injectable()
export class PdfGeneratorService {
    readonly apiPath = 'pdf-generator/';
    constructor(
      private http: HttpClient,
    ) { }

    generatePdf(template: HtmlTemplate): Observable<HttpResponse<Blob>> {    
        return this.http.post(this.apiPath, template, { responseType: 'blob', observe: 'response' });
    }
}
